function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3248_184)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.4246 17.3636C21.4246 17.7623 21.1107 18.0762 20.712 18.0762C20.3267 18.0762 20.0061 17.7556 20.0065 17.3708L20.0065 10.1439L8.08268 22.0678C7.80472 22.3457 7.35568 22.3529 7.07772 22.0749C6.79977 21.797 6.79977 21.3408 7.07772 21.0628L19.0016 9.13894L11.7814 9.14568C11.3894 9.13894 11.0684 8.81787 11.0688 8.43305C11.0688 8.0343 11.3827 7.72042 11.7814 7.72042L20.7192 7.72042C21.1045 7.72042 21.4251 8.04103 21.4246 8.42586L21.4246 17.3636Z",
  fill: "#3EED23"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3248_184"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(28.2852 15) rotate(135)"
})));

var SvgCredit = function SvgCredit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCredit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit.df1652ee.svg";
export { ForwardRef as ReactComponent };